import lodash from 'lodash'
import React, { useMemo } from 'react'

import Field, {
  required,
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import Input from '../../../../../../../1stlog-ui/src/components/Input'

const UnNumber = (props) => {
  const {} = props

  const specialInstructions = useField('specialInstructions')

  const isRequired = useMemo(
    () => lodash.includes(specialInstructions, '274'),
    [specialInstructions],
  )

  return (
    <Field
      key={isRequired}
      name="descriptionSpecialProvision"
      label={i18n.t('technical_naming', 'Technische Benennung')}
      validate={isRequired ? required : undefined}
      required={isRequired}
      tooltip={i18n.t(
        'description_special_provision_text',
        `Die offiziellen Benennungen für die Beförderung von Gattungseintragungen und "nicht anderweitig genannten" Eintragungen, denen in Kapitel 3.2 Tabelle A Spalte 6 die Sondervorschrift 274 zugeordnet ist, sind mit der technischen Benennung des Gutes zu ergänzen, sofern nicht ein nationales Gesetz oder ein internationales Übereinkommen bei Stoffen, die einer Kontrolle unterstehen, die genaue Beschreibung verbietet. Bei explosiven Stoffen und Gegenständen mit Explosivstoff der Klasse 1 darf die Beschreibung der gefährlichen Güter durch eine zusätzliche Beschreibung für die Angabe der Handelsnamen oder der militärischen Benennungen ergänzt werden. Eine geeignete nähere Bestimmung, wie «ENTHÄLT» oder «ENTHALTEND», oder andere bezeichnende Ausdrücke, wie «GEMISCH», «LÖSUNG», usw., und der Prozentsatz des technischen Bestandteils dürfen ebenfalls verwendet werden. Zum Beispiel: «ENTHÄLT XYLEN UND BENZEN».`,
      )}
    >
      <Input />
    </Field>
  )
}

export default UnNumber
